import { render } from "./ElementCarousel.vue?vue&type=template&id=ef983b04&scoped=true"
import script from "./ElementCarousel.vue?vue&type=script&lang=js"
export * from "./ElementCarousel.vue?vue&type=script&lang=js"

import "./ElementCarousel.vue?vue&type=style&index=0&id=ef983b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef983b04"]])

export default __exports__